/**
 * Qube Step Guide
 * Videos autoplay silently (like a GIF).
 * Uses IntersectionObserver to force play when in viewport, 
 * bypassing browser autoplay blocking bugs.
 */

(function () {
  'use strict';

  function initStepGuideVideos() {
    const videos = document.querySelectorAll('.qube-step-guide__video');
    if (!videos.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.muted = true; // Ensure muted for autoplay
            video.play().catch(function(e) {
              console.log("Autoplay blocked:", e);
            });
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.2 } // trigger when 20% visible
    );

    videos.forEach(function(video) {
      // Force muted and play inline properties
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      
      observer.observe(video);
      
      // Also attempt immediate play as a fallback
      video.play().catch(e => {});
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStepGuideVideos);
  } else {
    initStepGuideVideos();
  }

  // Re-init on Shopify section events (Theme Editor live reload)
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.qube-step-guide')) {
      initStepGuideVideos();
    }
  });
})();
